import { ExportableFilePopupSignatureSettings } from "../Api/Dto/ExportableFilePopupSignatureSettings";
import { ExportableFileSignatureSettingsModel } from "./ExportableFileSignatureSettingsModel";

class ExportableFilePopupSignatureSettingsModel {
    public isSaveSignature: boolean = false;
    public isAttachOriginalDocument: boolean = false;
    public isAlsoSendToPortal: boolean = false;
    public exportableFileSignatureSettings: ExportableFileSignatureSettingsModel[];

    public constructor(init?: Partial<ExportableFilePopupSignatureSettingsModel>) {
        Object.assign(this, init);
    }

    public static fromCacheModel(response: ExportableFilePopupSignatureSettings): ExportableFilePopupSignatureSettingsModel {
        if (!response)
            return null;

        return new ExportableFilePopupSignatureSettingsModel({
            isSaveSignature: response.IsSaveSignature,
            isAttachOriginalDocument: response.IsAttachOriginalDocument,
            isAlsoSendToPortal: response.IsAlsoSendToPortal,
            exportableFileSignatureSettings: ExportableFileSignatureSettingsModel.fromArrayCacheModel(response.ExportableFileSignatureSettings)
        });
    }

    public static toCacheModel(settings: ExportableFilePopupSignatureSettingsModel): ExportableFilePopupSignatureSettings {
        return new ExportableFilePopupSignatureSettings({
            IsSaveSignature: settings.isSaveSignature,
            IsAlsoSendToPortal: settings.isAlsoSendToPortal,
            IsAttachOriginalDocument: settings.isAttachOriginalDocument,
            ExportableFileSignatureSettings: ExportableFileSignatureSettingsModel.toArrayCacheModel(settings.exportableFileSignatureSettings)
        });
    }
}

export { ExportableFilePopupSignatureSettingsModel };
